import { z } from "zod";
export const productImageInfo = z.object({
    id: z.string().uuid(),
    productId: z.string().uuid(),
    imageUrl: z.string().url().nullable(),
    sourceType: z.string().nullable(),
    viewType: z.string().nullable(),
    sourceHash: z.string().nullable(),
    widthPx: z.number().int().nullable(),
    heightPx: z.number().int().nullable(),
    isPrimary: z.boolean(),
    isActive: z.boolean(),
    metadata: z.record(z.unknown()),
    createdAt: z.string().datetime(),
});
export const productImagesListResponse = z.object({ items: z.array(productImageInfo) });
export const uploadProductImageResponse = productImageInfo;
export const updateProductImageRequest = z
    .object({
    isPrimary: z.boolean().optional(),
    viewType: z
        .enum([
        "front",
        "back",
        "left",
        "right",
        "top",
        "bottom",
        "angled",
        "shelf_crop",
        "unknown",
    ])
        .optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: "At least one field required" });
export const deleteProductImageResponse = z.object({ ok: z.literal(true) });
// ── Per-image upload from URL ────────────────────────────────────────────
// Lets the operator add a product image by URL instead of file upload —
// shares the worker pipeline the bulk-import flow uses (download + SSRF
// guard + storage + embedding enqueue). The route is async by design: it
// validates the URL and the viewType, enqueues a product-image.fetch job,
// and returns 202 with `queued: true`. The image will appear on the
// Images tab once the worker completes (usually within seconds).
export const uploadProductImageFromUrlRequest = z.object({
    imageUrl: z.string().url(),
    viewType: z.enum([
        "front",
        "back",
        "left",
        "right",
        "top",
        "bottom",
        "angled",
        "shelf_crop",
        "unknown",
    ]),
});
export const uploadProductImageFromUrlResponse = z.object({
    ok: z.literal(true),
    queued: z.literal(true),
});
//# sourceMappingURL=product-images.schemas.js.map